module.exports = __webpack_public_path__ + "static/media/foto3.c29288ba.png";